import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Container, Loader2, KeyRound, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error("Missing reset token"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md bg-slate-900/90 border border-slate-700 rounded-lg p-8 shadow-2xl" data-testid="reset-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-md bg-orange-600 flex items-center justify-center"><Container className="h-5 w-5 text-white" /></div>
          <div className="font-heading font-extrabold tracking-wide text-xl uppercase">Set new password</div>
        </div>
        {!token ? (
          <p className="text-sm text-rose-400">Invalid or missing reset token. Request a new link.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-400">Choose a new password for your account.</p>
            <input
              type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password"
              placeholder="New password (min 6 chars)"
              className="w-full rounded-md bg-slate-950 border border-slate-700 px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-orange-500"
            />
            <button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-500 disabled:opacity-60 text-white font-semibold px-4 py-2.5 rounded-md transition-all active:scale-[0.98]">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Update password
            </button>
          </form>
        )}
        <Link to="/login" className="mt-4 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-slate-200"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
      </div>
    </div>
  );
}
